import React from 'react'
import T from 'prop-types'
import { CircularProgress, TableCell, TableRow } from '@mui/material'
import { styled } from '@mui/material/styles'

const classes = {
  message: 'message',
  hasError: 'has-error',
  isFetching: 'is-fetching',
}
const TableRowBodyNotLoaded = styled(TableRow)(({ theme }) => ({
  [`& .${classes.message}`]: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  [`& .${classes.hasError}`]: {
    color: theme.palette.error.main,
  },
  [`& .${classes.isFetching}`]: {
    minHeight: 41,
  },
}))

const TableBodyNotLoaded = ({ isFetching, error, colSpan }) => {
  return (
    <TableRowBodyNotLoaded>
      <TableCell colSpan={colSpan}>
        <div
          className={`${classes.message} ${error ? classes.hasError : ''} ${
            isFetching ? classes.isFetching : ''
          }`}
        >
          {isFetching ? (
            <CircularProgress />
          ) : error ? (
            error.message
          ) : (
            'No results'
          )}
        </div>
      </TableCell>
    </TableRowBodyNotLoaded>
  )
}

TableBodyNotLoaded.propTypes = {
  isFetching: T.bool,
  error: T.object,
  colSpan: T.number.isRequired,
}

export default TableBodyNotLoaded
